// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3\\+cV-{height:390px;border-top:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;background-color:#fff}.duqzA{padding:20px 16px}._2xpU0{position:relative;height:calc(100% - 64px);padding:0 16px 24px}.aWXup{display:flex}.aWXup:active{-webkit-tap-highlight-color:rgba(0,0,0,0)}.aWXup:active .MwBuS:before{background-color:rgba(24,23,22,.3)}.aWXup:active ._2UnvS{color:rgba(45,45,45,.8)}@media(any-hover:hover){.aWXup:hover .MwBuS:before{background-color:rgba(24,23,22,.3)}.aWXup:hover ._2UnvS{color:rgba(45,45,45,.8)}}.aWXup+.aWXup{margin-top:16px}.MwBuS{width:88px;height:88px;flex:0 0 88px;border-radius:8px}.MwBuS:before{position:absolute;z-index:1;top:0;left:0;width:100%;height:100%;background-color:rgba(24,23,22,0);content:\"\";transition:background-color .2s}._2UnvS{padding-left:16px;color:#2d2d2d;font-size:15px;line-height:20px;transition:color .2s}.N7AWA{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_3+cV-",
	"header": "duqzA",
	"body": "_2xpU0",
	"item": "aWXup",
	"image": "MwBuS",
	"content": "_2UnvS",
	"loader": "N7AWA"
};
module.exports = ___CSS_LOADER_EXPORT___;
